<div class="catalog-wrapper">
    <div class="catalog-item" *ngIf="catalog">
        <a da-link [routerLink]="catalog.url | localize">
            <div class="media">
                <figure *ngIf="catalogImage$ | async as catalogImage">
                    <da-progressive-image
                        [options]="{
                            alt: alt,
                            aspectRatios: [
                                {
                                    breakpoint: 360,
                                    width: 480,
                                    height: 320,
                                    akamaiImage: catalogImage
                                },
                                {
                                    breakpoint: 480,
                                    width: 780,
                                    height: 520,
                                    akamaiImage: catalogImage
                                },
                                {
                                    breakpoint: 768,
                                    width: 480,
                                    height: 320,
                                    akamaiImage: catalogImage
                                },
                                {
                                    breakpoint: 960,
                                    width: 380,
                                    height: 253,
                                    akamaiImage: catalogImage
                                },
                                {
                                    breakpoint: 1120,
                                    width: 480,
                                    height: 320,
                                    akamaiImage: catalogImage
                                }
                            ]
                        }"
                    ></da-progressive-image>
                </figure>
                <div class="content-md">
                    <div class="headline">
                        <h6>
                            {{ catalog.title }}
                        </h6>
                    </div>
                </div>
            </div>
        </a>
    </div>
</div>
